import gql from 'graphql-tag';

export const ListTagsQuery = gql`
  {
    ModelTags {
      _id
      title
    }
  }
`;

export const DeleteModelTagMutation = gql`
  mutation($query: JSON) {
    deleteModelTag(query: $query)
  }
`;

export const CreateModelTagMutation = gql`
  mutation($keyword: JSON) {
    createModelTag(record: $keyword) {
      _id
      title
    }
  }
`;
